/**
 * Created by andrey on 20.02.2026
 */

const SyncTransportClient = function (synchronizer) {
    SyncTransport.call(this, synchronizer);

    this.sendStatistics = connector.utils.accumulate(60000, () => this._sendStatistics());

    const AdapterClass = SyncTransportClient.detectAdapterClass();

    this.adapter = new AdapterClass();

    Object.assign(this.config, {
        sendInterval: 10000,
        loadSessionInterval: 5000
    }, { ...this.adapter.config });
};

SyncTransportClient.prototype = Object.create(SyncTransport.prototype);
SyncTransportClient.prototype.constructor = SyncTransportClient;

SyncTransportClient.prototype._connect = function (callback) {
    new ConnectorActionPlayer([
        (f) => connector.platform.whenConnected(f),

        (f) => {
            const loginRequired = connector.platform.oneOf(connector.MSSTART, connector.SAMSUNG, connector.ARKADIUM);

            if (!loginRequired) {
                f();
                return;
            }

            connector.social.whenConnected(() => {
                if (connector.social.isLoggedIn()) {
                    f();
                } else {
                    connector.social.once("login", f);
                }
            });
        }
    ]).play(callback);
};

SyncTransportClient.prototype._send = function (data, onSuccess, onFailure) {
    const debugMode = connector.config.debugMode;

    const options = {};

    if (data.syncout) {
        data.session = data.session || this.synchronizer.session;
        delete data.syncout;
        options.syncout = true;
    }

    const loadSession = options.syncout || (this.lastLoadSessionTime || 0) + this.config.loadSessionInterval < Date.now();
    if (loadSession) {
        this.lastLoadSessionTime = Date.now();
    }

    new ConnectorActionPlayer([
        (f) => {
            if (!loadSession) {
                f();
                return;
            }

            const start = Date.now();

            this.adapter.loadSession((session) => {
                debugMode && console.log(`sync loadSession success ${Date.now() - start}ms`, session);

                if (this.synchronizer.session !== session) {
                    onSuccess({ error: SyncTransport.SESSION_EXPIRED });
                } else {
                    f();
                }
            }, onFailure);
        },

        () => {
            const start = Date.now();

            this.saveCount = (this.saveCount || 0) + 1;
            this.sendStatistics();

            this.adapter.saveData(data, options, () => {
                debugMode && console.log(`sync saveData success ${Date.now() - start}ms`, data);

                this.saveSuccessCount = (this.saveSuccessCount || 0) + 1;
                this.sendStatistics();

                onSuccess();
            }, onFailure);
        }
    ]).play();
};

SyncTransportClient.prototype._checkSession = function (data, onSuccess, onFailure) {
    const debugMode = connector.config.debugMode;
    const start = Date.now();

    let storedSession, storedSync;
    let newSession, resolve;

    this.loadCount = (this.loadCount || 0) + 1;
    this.sendStatistics();

    new ConnectorActionPlayer([
        (f) => this.adapter.loadData((response) => {
            debugMode && console.log(`sync loadData ${Date.now() - start}ms`, response);

            this.loadSuccessCount = (this.loadSuccessCount || 0) + 1;
            this.sendStatistics();

            storedSession = response.session;

            response = { ...response };
            delete response.session;

            storedSync = response;
            f();
        }, (error) => {
            const errorMessage = error && (error.message || error);
            const errorCode = error && error.code;

            if (connector.platform.oneOf(connector.SAMSUNG)) {
                const userId = connector.platform.getUserID();
                connector.platform.getPlugin().bus.trigger("stream:console", "SAMSUNG_SYNC", `${userId} loadData failure ${Date.now() - start}ms ${errorMessage} code=${errorCode}`);
            }

            onFailure(error);
        }),

        (f) => {
            const session = this.synchronizer.session;

            debugMode && console.log(`sync checkSession ${session} ${storedSession}`);

            const compare = this.synchronizer.progressComparator(data, storedSync);

            if (session !== storedSession || compare < 0) {
                const number = Math.max(parseInt(storedSession) || 0, parseInt(session) || 0) + 1;
                newSession = `${number}_${Math.random().toString(16).slice(2)}`;
            }

            resolve = "equals";
            if (compare !== 0) {
                resolve = compare < 0 ? "remote" : "local";
            }

            connector.metrics.logEvent(connector.EVENTS.SYNC_STORAGE.RESOLVE + resolve);

            const kb = Math.ceil(JSON.stringify(storedSync).length / 1024);

            const bucket = [10, 25, 50, 100, 150, 175].find((size) => kb <= size) || 200;
            connector.metrics.logEvent(connector.EVENTS.SYNC_STORAGE.DATA_SIZE_BUCKET + bucket);

            console.log(`sync checkSession ${resolve} size ${kb}k`);

            f();
        },

        (f) => {
            if (!newSession) {
                f();
                return;
            }

            connector.metrics.logEvent(connector.EVENTS.SYNC_STORAGE.SAVE_SESSION);

            const start = Date.now();

            this.adapter.saveData({ session: newSession }, {}, () => {
                debugMode && console.log(`sync saveData success ${newSession} ${Date.now() - start}ms`);

                connector.metrics.logEvent(connector.EVENTS.SYNC_STORAGE.SAVE_SESSION_SUCCESS);
                f();
            }, onFailure);
        },

        () => onSuccess({
            session: newSession,
            snapshot: resolve === "remote" ? storedSync : undefined
        })
    ]).play();
};

SyncTransportClient.prototype.canSend = function () {
    return this.adapter.canSaveData ? this.adapter.canSaveData() : true;
};

SyncTransportClient.prototype._sendStatistics = function () {
    const events = {
        [connector.EVENTS.SYNC_STORAGE.LOAD]: this.loadCount,
        [connector.EVENTS.SYNC_STORAGE.LOAD_SUCCESS]: this.loadSuccessCount,
        [connector.EVENTS.SYNC_STORAGE.SAVE]: this.saveCount,
        [connector.EVENTS.SYNC_STORAGE.SAVE_SUCCESS]: this.saveSuccessCount
    };

    for (const event in events) {
        if (!events[event]) {
            continue;
        }

        connector.metrics.logEvent(event, { value: events[event] });
    }

    this.loadCount = 0;
    this.loadSuccessCount = 0;
    this.saveCount = 0;
    this.saveSuccessCount = 0;
};

SyncTransportClient.isAppropriate = function () {
    return connector.platform.oneOf(connector.ARKADIUM) || connector.config.platformsync
        && (connector.platform.oneOf(
            connector.YANDEX,
            connector.SAMSUNG,
            connector.MSSTART,
            connector.TEST,
            connector.VK
        )
        || (connector.platform.oneOf(connector.INSTANT) && !connector.config.facebookLogin));
};

SyncTransportClient.detectAdapterClass = function () {
    const adapters = {
        yandex: YandexTransportAdapter,
        samsung: SamsungTransportAdapter,
        msstart: MSStartTransportAdapter,
        test: TestTransportAdapter,
        instant: InstantTransportAdapter,
        vk: VKTransportAdapter,
        arkadium: ArkadiumTransportAdapter
    };

    const source = connector.info.source;

    return adapters[source];
};
